// src/lib/dashboard/periodoAnterior.ts
//
// O período anterior EQUIVALENTE ao selecionado — é contra ele que a Visão
// geral compara cada número.
//
// Equivalente = mesmo tamanho, colado antes. "Mês atual" compara com o mês
// passado; "Últimos 3 meses" compara com os 3 meses anteriores a esses.
// Comparar com um pedaço de tamanho diferente produziria uma variação que não
// significa nada — 12 meses contra 1 sempre "cresce".
//
// "Todo o histórico" não tem anterior: devolve `null`, e quem exibe esconde a
// variação em vez de inventar uma base.
//
// Função pura, sem I/O nem JSX: roda sob `node --test` com type-stripping.

import type { PeriodoDashboard } from './periodoDashboard.ts';
import { calcularJanelaPeriodoDashboard } from './periodoDashboard.ts';

const yyyyMm = (d: Date): string => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;

export function periodoAnteriorEquivalente(periodo: PeriodoDashboard, hoje: Date): PeriodoDashboard | null {
  const janela = calcularJanelaPeriodoDashboard(periodo, hoje);
  if (!janela) return null; // "Todo o histórico" — não existe anterior

  const inicio = janela.inicio;
  const fim = janela.fim;
  const meses = (fim.getFullYear() - inicio.getFullYear()) * 12 + (fim.getMonth() - inicio.getMonth()) + 1;

  const fimAnterior = new Date(inicio.getFullYear(), inicio.getMonth() - 1, 1);
  const inicioAnterior = new Date(fimAnterior.getFullYear(), fimAnterior.getMonth() - (meses - 1), 1);
  return { tipo: 'range', inicio: yyyyMm(inicioAnterior), fim: yyyyMm(fimAnterior) };
}

/** Variação percentual de `atual` sobre `anterior`. `null` quando não dá para dividir. */
export function variacaoPct(atual: number, anterior: number): number | null {
  if (!Number.isFinite(atual) || !Number.isFinite(anterior) || anterior === 0) return null;
  return (atual / anterior - 1) * 100;
}
